import _ from "lodash";
export const selectProfile = ({ ToolBoxReport_reducer }) => {
    return ToolBoxReport_reducer.profile;
};
export const selectUserProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const getRequesting = ({ ToolBoxReport_reducer }) => {
    return ToolBoxReport_reducer.requesting;
};
export const getUserIcons = ({ MainReducer }) => {
    if (MainReducer.users) {
        let users = {};
        Object.keys(MainReducer.users).map((e) => {
            users = _.assign(users, {
                [e]: MainReducer.users[e].profile.profile_image_url,
            });
            return null;
        });
        return users;
    } else return false;
};
export const selectToolType = ({ ToolBoxReport_reducer }) => {
    return ToolBoxReport_reducer.toolboxTypes
        ? Object.keys(ToolBoxReport_reducer.toolboxTypes).map(
              (e) => ToolBoxReport_reducer.toolboxTypes[e]
          )
        : [];
};
